module.exports = __webpack_public_path__ + "img/Business-Intelligence.1c6bdbbf.jpg";